export enum CrossServices {
  'VGO' = 4,
  'CSGO' = 2,
  'DOTA2' = 3,
  'REAL' = 1,
}
